<template>
	<section>
		<!-- barra breadcrumb + bottone nuovo utente e bottone nuovo admin -->
		<header class="breadcrumb">
			<span>Account {{ isAdmin ? "➠ Gestione degli utenti" : "" }}</span>
			<!-- gruppo bottoni a destra -->
			<div
				v-if="isAdmin"
				class="breadcrumb-actions"
			>
				<button
					class="btn-new"
					@click="showAddUserModal = true"
				>
					+ Nuovo utente
				</button>
				<button
					class="btn-new"
					@click="showAddModal = true"
				>
					+ Nuovo admin
				</button>
				<NotificationBell
					v-if="showCrumbBell"
					placement="header"
				/>
			</div>
		</header>

		<!-- MESSAGGI DI STATO -->
		<p
			v-if="loading"
			class="msg"
		>
			Caricamento…
		</p>
		<p
			v-else-if="error && isAdmin"
			class="msg error"
		>
			{{ error }}
		</p>

		<!-- LISTA ADMIN (temporaneamente visibile solo agli amministratori) -->

		<!-- <span
			v-if="isAdmin"
			class="manage-title"
			>Gestione degli utenti</span
		> -->
		<div
			v-if="isAdmin && usersList.length"
			class="tbl-wrap"
		>
			<table class="tbl">
				<thead>
					<tr>
						<th>ID</th>
						<th>Email</th>
						<th>Ruolo</th>
						<th>Device condivisi</th>
						<th>Creato il</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="(adm, i) in usersList"
						:key="adm.id"
						:class="i % 2 && 'alt'"
					>
						<td class="mono">{{ adm.id }}</td>
						<td>{{ adm.email }}</td>
						<td>
							<span
								class="account-badge"
								:class="adm.is_admin ? 'admin' : 'user'"
							>
								{{ adm.is_admin ? "Admin" : "User" }}
							</span>
						</td>
				<td>
					<span
						v-if="!adm.is_admin"
						class="shared-count-badge"
						:class="{ 'has-devices': getSharedDevicesCount(adm) > 0 }"
					>
						{{ getSharedDevicesCount(adm) }} device{{ getSharedDevicesCount(adm) !== 1 ? 's' : '' }}
					</span>
					<span v-else class="text-muted">—</span>
				</td>
				<td>{{ formatDate(adm.createdAt || adm.created_at) }}</td>
						<td class="actions">
							<button
								v-if="isAdmin && !adm.is_admin"
								title="Condividi devices"
								class="share-btn"
								@click="openShareModal(adm)"
							>
								<ShareIcon />
							</button>
							<span
								class="archived-user-icon"
								v-if="adm.id !== me.id && isAdmin && adm.is_archived"
								title="Utente archiviato"
							>
								<ArchiveIcon />
							</span>
							<button
								v-if="adm.id !== me.id && isAdmin"
								title="Rimuovi utente"
								@click="openRemoveAdminModal(adm)"
							>
								<TrashIcon />
							</button>
							<button
								class="restore-icon"
								v-if="adm.id !== me.id && isAdmin"
								title="Ripristina utente"
								@click="openRestoreAdminModal(adm)"
							>
								<ArchiveRestoreIcon />
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<!-- CAMBIO PASSWORD -->
		<div class="account-cards">
			<div class="account-card">
				<h3>Cambia password</h3>
				<form
					class="form"
					@submit.prevent="changePassword"
				>
					<!-- vecchia password -->
					<div class="field-group">
						<label>Vecchia password</label>
						<div class="input-wrap">
							<input
								v-model="oldPwd"
								:type="showOld ? 'text' : 'password'"
								required
								@input="verifyOldPassword"
								@blur="verifyOldPassword"
								:class="{ invalid: oldPwdValid === false }"
							/>
							<button
								type="button"
								class="eye"
								@click="showOld = !showOld"
							>
								<component :is="showOld ? EyeOffIcon : EyeIcon" />
							</button>
						</div>
						<p
							v-if="oldPwdValid === false"
							class="err"
						>
							* Password non corretta
						</p>
					</div>

					<!-- nuova password -->
					<div class="field-group">
						<label>Nuova password</label>
						<div class="input-wrap">
							<input
								v-model="newPwd"
								:type="showNew ? 'text' : 'password'"
								required
							/>
							<button
								type="button"
								class="eye"
								@click="showNew = !showNew"
							>
								<component :is="showNew ? EyeOffIcon : EyeIcon" />
							</button>
						</div>
					</div>

					<!-- conferma -->
					<div class="field-group">
						<label>Conferma nuova password</label>
						<div class="input-wrap">
							<input
								v-model="newPwd2"
								:type="showNew2 ? 'text' : 'password'"
								required
								:class="{ invalid: newPwd2 && !newPwdsMatch }"
							/>
							<button
								type="button"
								class="eye"
								@click="showNew2 = !showNew2"
							>
								<component :is="showNew2 ? EyeOffIcon : EyeIcon" />
							</button>
						</div>
						<p
							v-if="newPwd2 && !newPwdsMatch"
							class="err"
						>
							* Le nuove password non coincidono
						</p>
					</div>
					<button
						class="btn-primary"
						:disabled="pwdLoading || !oldPwd || !newPwdsMatch || oldPwdValid === false || checkingOldPwd"
					>
						Aggiorna
					</button>
				</form>
			</div>

			<!-- ELIMINA ACCOUNT -->
			<div class="account-card danger">
				<h3>Elimina account</h3>
				<p>Operazione <strong>irreversibile</strong>. Tutti i tuoi dati verranno rimossi e il tuo account eliminato entro 7 giorni.</p>
				<button
					class="btn-danger"
					@click="showDeleteModal = true"
				>
					Cancella account
				</button>
			</div>
		</div>

		<!-- ───────── MODALS ───────── -->

		<!-- Aggiunta nuovo admin -->
		<div
			v-if="showAddModal"
			class="modal-mask"
		>
			<div class="modal">
				<h3>Nuovo amministratore</h3>

				<label class="modal-label">Email</label>
				<input
					v-model.trim="newAdminEmail"
					class="modal-input"
					type="email"
					placeholder="email@dominio.com"
				/>
				<div class="modal-actions">
					<button
						:disabled="addLoading || !newAdminEmail"
						@click="confirmAddAdmin"
					>
						OK
					</button>
					<button
						:disabled="addLoading"
						@click="closeAddModal"
					>
						Annulla
					</button>
				</div>
			</div>
		</div>

		<!-- Aggiunta nuovo utente -->
		<div
			v-if="showAddUserModal"
			class="modal-mask"
		>
			<div class="modal">
				<h3>Nuovo utente</h3>

				<label class="modal-label">Email</label>
				<input
					v-model.trim="newUserEmail"
					class="modal-input"
					type="email"
					placeholder="email@dominio.com"
				/>

				<label
					class="modal-label"
					style="margin-top: 12px"
					>Password (opzionale)</label
				>
				<div class="modal-input-wrap">
					<input
						v-model="newUserPassword"
						:type="showUserPwd ? 'text' : 'password'"
						class="modal-input"
						placeholder="password (default: 'password')"
					/>
					<button
						type="button"
						class="eye"
						@click="showUserPwd = !showUserPwd"
					>
						<component :is="showUserPwd ? EyeOffIcon : EyeIcon" />
					</button>
				</div>

				<div class="modal-actions">
					<button
						:disabled="addUserLoading || !newUserEmail"
						@click="confirmAddUser"
					>
						OK
					</button>
					<button
						:disabled="addUserLoading"
						@click="closeAddUserModal"
					>
						Annulla
					</button>
				</div>
			</div>
		</div>

		<!-- Rimozione admin -->
		<div
			v-if="showRemoveAdminModal"
			class="modal-mask"
		>
			<div class="modal">
				<h3>Rimuovi {{ selectedAdmin?.is_admin ? "Amministratore" : "Utente" }}</h3>
				<p>
					Sei sicuro di voler rimuovere
					<strong>{{ selectedAdmin?.email }}</strong
					>?
				</p>
				<p>Questa azione non può essere annullata.</p>
				<div class="modal-actions">
					<button
						:disabled="removeAdminLoading"
						@click="removeAdmin"
					>
						Rimuovi
					</button>
					<button
						:disabled="removeAdminLoading"
						@click="showRemoveAdminModal = false"
					>
						Annulla
					</button>
				</div>
			</div>
		</div>
		<!-- Ripristino admin -->
		<div
			v-if="showRestoreAdminModal"
			class="modal-mask"
		>
			<div class="modal">
				<h3>Ripristina {{ selectedAdmin?.is_admin ? "Amministratore" : "Utente" }}</h3>
				<p>
					Sei sicuro di voler ripristinare
					<strong>{{ selectedAdmin?.email }}</strong
					>?
				</p>
				<div class="modal-actions">
					<button
						:disabled="removeAdminLoading"
						@click="restoreAdmin"
					>
						Ripristina
					</button>
					<button
						:disabled="removeAdminLoading"
						@click="showRestoreAdminModal = false"
					>
						Annulla
					</button>
				</div>
			</div>
		</div>

		<!-- Conferma eliminazione account -->
		<div
			v-if="showDeleteModal"
			class="modal-mask"
		>
			<div class="modal">
				<h3>Conferma eliminazione</h3>
				<p>Inserisci la tua password per confermare:</p>
				<input
					v-model="delPwd"
					class="modal-input"
					type="password"
					placeholder="Password"
				/>
				<div class="modal-actions">
					<button
						:disabled="delLoading || !delPwd"
						@click="confirmDelete"
					>
						Elimina
					</button>
					<button
						:disabled="delLoading"
						@click="closeDeleteModal"
					>
						Annulla
					</button>
				</div>
			</div>
		</div>

		<!-- Condivisione device -->
		<DeviceShareModal
			v-if="showShareModal"
			:user="selectedUserForShare"
			@close="closeShareModal"
		/>
	</section>
</template>

<script setup lang="ts">
	import axios from "@/axiosInstance";
	import router, { setAuth } from "@/router";
	import dayjs from "dayjs";
	import { Archive as ArchiveIcon, ArchiveRestore as ArchiveRestoreIcon, Eye as EyeIcon, EyeOff as EyeOffIcon, Share2 as ShareIcon, Trash as TrashIcon } from "lucide-vue-next";
	import type { Ref } from "vue";
	import { computed, inject, nextTick, onMounted, ref } from "vue";
	import { useToast } from "vue-toast-notification";
	import DeviceShareModal from "./DeviceShareModal.vue";
	import NotificationBell from "./NotificationBell.vue";

	const isDesktop = inject<Ref<boolean>>("isDesktop")!;
	const isSidebarOpen = inject<Ref<boolean>>("isSidebarOpen")!;

	const showCrumbBell = computed(() => !isDesktop.value || (isDesktop.value && !isSidebarOpen.value));

	/* ─── stato utente ─── */
	const me = ref<any>({});
	const isAdmin = computed(() => me.value.is_admin);

	/* ─── lista admin ─── */
	const usersList = ref<any[]>([]);
	const loading = ref(true);
	const error = ref<string | null>(null);

	/* ─── toast ─── */
	const toast = useToast();

	/* ─── cambio password ─── */
	const oldPwd = ref("");
	const newPwd = ref("");
	const newPwd2 = ref("");
	const pwdLoading = ref(false);

	const showOld = ref(false); // 👁️
	const showNew = ref(false);
	const showNew2 = ref(false);

	const oldPwdValid = ref<null | boolean>(null); // null = non controllata
	const checkingOldPwd = ref(false);
	let timer: ReturnType<typeof setTimeout> | null = null;

	const newPwdsMatch = computed(() => newPwd.value && newPwd2.value && newPwd.value === newPwd2.value);

	/* ─── aggiunta admin ─── */
	const showAddModal = ref(false);
	const newAdminEmail = ref("");
	const addLoading = ref(false);

	/* ─── aggiunta utente ─── */
	const showAddUserModal = ref(false);
	const newUserEmail = ref("");
	const newUserPassword = ref(""); // opzionale
	const addUserLoading = ref(false);
	const showUserPwd = ref(false);

	/* ─── rimozione admin (solo per admin) ─── */
	const showRemoveAdminModal = ref(false);
	const showRestoreAdminModal = ref(false);
	const selectedAdmin = ref<any | null>(null);
	const removeAdminLoading = ref(false);


	/* ─── condivisione device (solo per admin) ─── */
	const showShareModal = ref(false);
	const selectedUserForShare = ref<any | null>(null);
	const sharedDevicesMap = ref<Record<number, number[]>>({}); // userId -> deviceIds[]

	/* ─── elimina account ─── */
	const showDeleteModal = ref(false);
	const delPwd = ref("");
	const delLoading = ref(false);

	onMounted(fetchData);

	async function fetchData() {
		loading.value = true;
		try {
			// 1. chiedo solo /auth/me
			const { data: user } = await axios.get("/auth/me");
			me.value = user;

			// 2. se è admin, recupero la lista; altrimenti la lascio vuota
			if (me.value.is_admin) {
				const { data: users } = await axios.get("/auth/get-users");
				usersList.value = users;

				// 3. Per ogni utente non-admin, carico i device condivisi
				await loadSharedDevicesForUsers();
			} else {
				usersList.value = []; // niente tabella per i non-admin
			}
		} catch (e: any) {
			// mostro l'errore solo se l'utente è admin (→ errore reale)
			if (me.value.is_admin) {
				error.value = e.response?.data?.details || "Errore caricamento";
			} else {
				error.value = null; // silenzio per i non-admin
			}
		} finally {
			loading.value = false;
		}
	}

	// Carica i device condivisi per tutti gli utenti
	async function loadSharedDevicesForUsers() {
		const nonAdminUsers = usersList.value.filter((u) => !u.is_admin);

		for (const user of nonAdminUsers) {
			try {
				const { data } = await axios.get(`/auth/${user.id}/shared-devices`, { withCredentials: true });
				// Assumiamo che data sia un array di ID o un oggetto { devices: [...] }
				const deviceIds = Array.isArray(data) ? data.map((x: any) => (typeof x === "object" ? x.id : x)) : data.devices?.map((x: any) => (typeof x === "object" ? x.id : x)) || [];

				sharedDevicesMap.value[user.id] = deviceIds;
			} catch (e) {
				// Se l'endpoint non esiste ancora o c'è un errore, ignora
				sharedDevicesMap.value[user.id] = [];
			}
		}
	}

	// Funzione helper per ottenere il conteggio
	function getSharedDevicesCount(user: any): number {
		return sharedDevicesMap.value[user.id]?.length || 0;
	}

	// Verifica vecchia password al blur (con debounce 400 ms)
	async function verifyOldPassword() {
		if (timer) clearTimeout(timer);
		timer = setTimeout(async () => {
			if (!oldPwd.value) return (oldPwdValid.value = null);

			try {
				checkingOldPwd.value = true;
				const { data } = await axios.post("/auth/verify-password", {
					password: oldPwd.value,
				});
				oldPwdValid.value = data.ok; // true / false
			} catch {
				oldPwdValid.value = false;
			} finally {
				checkingOldPwd.value = false;
			}
		}, 400);
	}

	/* ─── cambio password ─── */
	async function changePassword() {
		if (newPwd.value !== newPwd2.value) {
			toast.error("Le nuove password non coincidono", {
				position: "top-right",
				duration: 2500,
			});
			return;
		}
		if (!oldPwd.value) {
			toast.info("La vecchia password è necessaria per effettuare la sua verifica", {
				position: "top-right",
				duration: 2500,
			});
			return;
		} else if (!newPwd.value) {
			toast.info("Il campo nuova password è necessario", {
				position: "top-right",
				duration: 2500,
			});
			return;
		}

		try {
			pwdLoading.value = true;
			const response = await axios.patch("/auth/change-password", {
				oldPassword: oldPwd.value,
				newPassword: newPwd.value,
			});

			toast.success(response.data || "Password aggiornata con successo ✔︎", {
				position: "top-right",
				duration: 2000,
			});
			oldPwd.value = newPwd.value = newPwd2.value = "";

			// logout & redirect
			setTimeout(() => {
				setAuth(false);
				router.push("/auth");
			}, 2000);
		} catch (e: any) {
			toast.error(e.response?.data?.details || "Errore cambio password", {
				position: "top-right",
				duration: 2500,
			});
		} finally {
			pwdLoading.value = false;
		}
	}

	async function confirmAddUser() {
		if (!isAdmin.value) return;

		try {
			addUserLoading.value = true;
			const payload = {
				email: newUserEmail.value,
				role: "user",
				password: newUserPassword.value?.trim() || "password",
			};
			const { data } = await axios.post("/auth/register-user", payload);

			// aggiorno la lista in tabella
			usersList.value.push(data.user);

			toast.success("Nuovo utente aggiunto", {
				position: "top-right",
				duration: 2500,
			});

			closeAddUserModal();
		} catch (e: any) {
			toast.error(e.response?.data?.details || "Errore aggiunta utente", {
				duration: 2500,
			});
		} finally {
			addUserLoading.value = false;
		}
	}
	function closeAddUserModal() {
		showAddUserModal.value = false;
		newUserEmail.value = "";
		newUserPassword.value = "";
		showUserPwd.value = false;
	}

	/* ─── aggiungi admin ─── */
	async function confirmAddAdmin() {
		try {
			addLoading.value = true;
			const payload = {
				email: newAdminEmail.value,
				role: "admin",
				password: "password",
			};
			const { data } = await axios.post("/auth/register-user", payload);
			usersList.value.push(data.user);
			toast.success("Nuovo admin aggiunto", {
				position: "top-right",
				duration: 2500,
			});
			closeAddModal();
		} catch (e: any) {
			// console.error(e);
			toast.error(e.response?.data?.details || "Errore aggiunta admin", {
				duration: 2500,
			});
		} finally {
			addLoading.value = false;
		}
	}
	function closeAddModal() {
		showAddModal.value = false;
		newAdminEmail.value = "";
	}

	/* ─── rimuovi admin (solo per admin) ─── */
	function openRemoveAdminModal(adm: any) {
		if (!isAdmin.value) return;
		selectedAdmin.value = adm;
		showRemoveAdminModal.value = true;
	}

	/* ─── ripristina admin (solo per admin) ─── */
	function openRestoreAdminModal(adm: any) {
		if (!isAdmin.value) return;
		selectedAdmin.value = adm;
		//   console.log("selectedAdmin.value", selectedAdmin.value);
		showRestoreAdminModal.value = true;
	}

	async function removeAdmin() {
		const adm = selectedAdmin.value;
		if (!adm) return;

		if (!isAdmin.value) return;
		if (adm.id === me.value.id) {
			toast.error("Non puoi rimuovere te stesso", { duration: 2500 });
			return;
		}

		removeAdminLoading.value = true;
		try {
			await axios.post(`/auth/${adm.id}/archive-admin`);
			// usersList.value = usersList.value.filter((a) => a.id !== adm.id);
			toast.success(`${adm.is_admin ? "Admin" : "Utente"} ${adm.email} rimosso`, {
				position: "top-right",
				duration: 2000,
			});
			adm.is_archived = true;
			closeRemoveAdminModal();
		} catch (e: any) {
			closeRemoveAdminModal();
			console.error(e);
			toast.error(e.response?.data?.details || "Errore rimozione", {
				position: "top-right",
				duration: 2500,
			});
		}
	}

	async function restoreAdmin() {
		const adm = selectedAdmin.value;
		if (!adm) return;

		if (!isAdmin.value) return;
		if (adm.id === me.value.id) {
			toast.error("Non puoi ripristinare te stesso", { duration: 2500 });
			return;
		}

		removeAdminLoading.value = true;
		try {
			const { data } = await axios.post(`/auth/${adm.id}/restore`);
			// usersList.value = usersList.value.filter((a) => a.id !== adm.id);
			toast.success(`${adm.is_admin ? "Admin" : "Utente"} ${adm.email} ripristinato`, {
				position: "top-right",
				duration: 2000,
			});
			adm.is_archived = false;
			closeRestoreAdminModal();
		} catch (e: any) {
			closeRestoreAdminModal();
			console.error(e);
			toast.error(e.response?.data?.details || "Errore ripristino", {
				position: "top-right",
				duration: 2500,
			});
		}
	}

	function closeRemoveAdminModal() {
		showRemoveAdminModal.value = false;
		selectedAdmin.value = null;
		removeAdminLoading.value = false;
	}

	function closeRestoreAdminModal() {
		showRestoreAdminModal.value = false;
		selectedAdmin.value = null;
		removeAdminLoading.value = false;
	}

	/* ─── condivisione device ─── */
	function openShareModal(user: any) {
		selectedUserForShare.value = user;
		showShareModal.value = true;
	}
	function closeShareModal() {
		showShareModal.value = false;
		selectedUserForShare.value = null;
		// Ricarica i device condivisi per aggiornare il count
		if (isAdmin.value) {
			loadSharedDevicesForUsers();
		}
	}

	/* ─── elimina account ─── */
	async function confirmDelete() {
		try {
			delLoading.value = true;
			const response = await axios.post(`/auth/delete-account`, { password: delPwd.value }, { withCredentials: true });
			toast.success(response.data || `L'account è stato programmato per l'eliminazione (entro 7 giorni).`, {
				position: "top-right",
				duration: 2000,
			});

			closeDeleteModal();

			// logout e redirect a login
			setTimeout(() => {
				setAuth(false);
				router.push("/auth");
			}, 2000);
		} catch (e: any) {
			toast.error(e.response?.data?.message || "Password errata", {
				position: "top-right",
				duration: 2500,
			});
		} finally {
			delLoading.value = false;
		}
	}

	function closeDeleteModal() {
		showDeleteModal.value = false;
		delPwd.value = "";
	}

	/* ─── util ─── */
	function formatDate(iso: string) {
		return dayjs(iso).isValid() ? dayjs(iso).format("DD/MM/YYYY HH:mm") : "—";
	}
</script>

<style scoped>
	.breadcrumb-actions {
		display: flex;
		align-items: center;
		gap: 12px; /* distanza tra i due bottoni */
	}

	.err {
		margin-top: 4px;
		font-size: 13px;
		color: #e74c3c;
	}
	/* account-cards semplice per sezioni */
	.account-cards {
		display: flex;
		flex-wrap: wrap; /* va a capo quando serve */
		gap: 40px 32px; /* righe/colonne */
		margin: 40px 24px;
	}
	.account-card {
		flex: 0 0 350px; /* “tile” largo 350px */
		max-width: 100%;
		padding: 24px;
		background: #fff;
		border: 1px solid #ddd;
		border-radius: 6px;
	}
	.account-card h3 {
		margin: 0 0 16px;
		font: 600 18px/1 "Inter", sans-serif;
	}
	.account-card.danger {
		border-color: #e74c3c;
		background: #fff7f7;
	}

	/* form */
	.form {
		display: grid;
		gap: 16px;
		max-width: 340px;
	}

	/* contenitore input + icona */
	.input-wrap {
		position: relative;
	}

	/* bottone “occhio” a destra dell’input */
	.eye {
		position: absolute;
		right: 10px;
		top: 50%;
		transform: translateY(-50%);
		background: none;
		border: 0;
		padding: 0;
		cursor: pointer;
	}

	.eye svg {
		width: 20px;
		height: 20px;
		stroke: #666; /* colore icona */
	}

	.eye:hover svg {
		stroke: #008f8f; /* highlight on hover */
	}

	.field-group {
		display: flex;
		flex-direction: column;
		gap: 4px;
	}
	.field-group label {
		font-size: 14px;
		font-weight: 600;
	}
	.field-group input {
		width: 100%; /* riempi la account-card */
		padding: 8px 12px;
		border: 1px solid #bbb;
		border-radius: 4px;
		transition: border-color 0.2s, border-radius 0.2s;
	}

	/* colore bordo quando il campo è attivo / selezionato */
	.field-group input:focus {
		outline: none;
		border: 2px solid #008f8f;
		/* border-color: #008f8f;
		/* opzionale: leggero glow */
		box-shadow: 0 0 0 2px rgba(0, 143, 143, 0.25);
	}

	.field-group input.invalid {
		border: 2px solid #e74c3c; /* rosso */
	}

	.field-group input:valid:not(.invalid) {
		border: 2px solid #008f8f;
	}

	.account-badge {
		padding: 2px 8px;
		border-radius: 10px;
		font: 600 12px/1 Inter;
	}
	.account-badge.admin {
		background: #fff0;
		border: 1px solid #008f8f;
		color: #008f8f;
		position: relative;
	}
	.account-badge.user {
		background: #eef6;
		border: 1px solid #99a;
		color: #334;
		position: relative;
	}

	.shared-count-badge {
		display: inline-block;
		padding: 4px 8px;
		border-radius: 12px;
		font-size: 12px;
		font-weight: 500;
		background: #f5f5f5;
		color: #666;
		border: 1px solid #ddd;
	}

	.shared-count-badge.has-devices {
		background: #e0f7fa;
		color: #00838f;
		border-color: #00838f;
		font-weight: 600;
	}

	.text-muted {
		color: #999;
	}

	.btn-primary,
	.btn-new {
		padding: 10px 18px;
		background: #008f8f;
		border: 0;
		color: #fff;
		border-radius: 4px;
		cursor: pointer;
		font: 600 14px/1 "Inter", sans-serif;
		transition: background 0.15s;
	}
	.btn-primary:hover {
		background: #00a7a7;
	}
	.btn-primary:active {
		background: #007777;
	}

	.btn-primary:disabled {
		opacity: 0.5;
		cursor: auto;
		/* background-color: grey; */
	}

	.btn-danger {
		padding: 10px 18px;
		background: #e74c3c;
		border: 0;
		color: #fff;
		border-radius: 4px;
		cursor: pointer;
		font: 600 14px/1 "Inter", sans-serif;
		transition: background 0.15s;
		margin-top: 1rem;
	}
	.btn-danger:hover {
		background: #ff4d4d;
	}
	.btn-danger:active {
		background: #c0392b;
	}

	@media (max-width: 1024px) {
		.breadcrumb span {
			font-size: 16px;
		}

		.btn-primary,
		.btn-new {
			padding: 5px 5px;
		}
	}

	@media (max-width: 932px) {
		.breadcrumb {
			padding: 50px 45px;
		}
		.account-cards {
			flex-direction: column; /* stack verticale */
			gap: 32px;
			margin: 24px;
		}
	}

	/***** modals (riuso DevicesList) *****/
	.modal-mask {
		position: fixed;
		inset: 0;
		background: rgba(0, 0, 0, 0.55);
		backdrop-filter: blur(3px);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 9999;
	}
	.modal {
		min-width: 320px;
		max-width: 90%;
		background: #0d0d0d;
		color: #fff;
		padding: 28px 32px;
		border-radius: 8px;
		box-shadow: 0 18px 40px rgba(0, 0, 0, 0.35);
		animation: pop 0.25s ease-out;
	}
	@keyframes pop {
		from {
			opacity: 0;
			transform: scale(0.92);
		}
		to {
			opacity: 1;
			transform: scale(1);
		}
	}

	/* etichetta nel modale */
	.modal-label {
		display: block;
		font: 600 14px/1 "Inter", sans-serif;
		margin-bottom: 6px;
	}

	/* wrapper per input con icona occhio nel modale */
	.modal-input-wrap {
		position: relative;
	}
	.modal-input-wrap .eye {
		position: absolute;
		right: 10px;
		top: 60%;
		transform: translateY(-50%);
		background: none;
		border: 0;
		padding: 0;
		cursor: pointer;
	}
	.modal-input-wrap .eye svg {
		width: 20px;
		height: 20px;
		stroke: #ccc;
	}
	.modal-input-wrap .eye:hover svg {
		stroke: #00a7a7;
	}

	.modal-input {
		width: 100%;
		padding: 10px 12px;
		border: 1px solid #444;
		border-radius: 5px;
		background: #1a1a1a;
		color: #eee;
		transition: border 0.2s;
		margin-top: 12px;
	}
	.modal-input:focus {
		outline: none;
		border-color: #008f8f;
	}
	.modal-actions {
		margin-top: 26px;
		display: flex;
		justify-content: flex-end;
		gap: 12px;
	}
	.modal-actions button {
		min-width: 88px;
		padding: 8px 16px;
		font: 600 14px/1 "Inter", sans-serif;
		border-radius: 4px;
		cursor: pointer;
		color: #fff;
		background: #008f8f;
		border: 1px solid #008f8f;
		transition: background 0.15s;
	}
	.modal-actions button:hover {
		background: #00a7a7;
	}
	.modal-actions button:active {
		background: #007777;
	}

	.actions {
		text-align: right;
	}

	/***** override azioni tabella *****/
	.actions button {
		background: none;
		border: 0;
		cursor: pointer;
		padding: 0 5px;
	}

	.actions span.archived-user-icon {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: 0 5px;
		cursor: default; /* opzionale, per indicare che non è cliccabile */
	}

	.actions svg {
		width: 18px;
		height: 18px;
		stroke: #000;
		transition: 0.2s;
	}
	.actions svg:hover {
		stroke: #e74c3c;
	}

	.restore-icon svg:hover {
		stroke: #008f8f;
	}

	.share-btn svg:hover {
		stroke: #008f8f;
	}

	.archived-user-icon svg {
		stroke: #ff4d4d;
	}

	.tbl-wrap {
		margin-top: 10px;
		border: 1px solid #ddd;
		border-radius: 4px;
		max-height: 200px;
		overflow-x: auto;
	}

	/* .manage-title {
		font-weight: 700;
		margin-top: 1rem;
		padding: 0rem 0rem 0rem 1.4rem;
		margin-bottom: 1rem;
	} */
</style>
